import React, { useEffect, useRef, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import FloatingCard from './FloatingCard';

function FloatingCard3D({ url, cardText, onClick }) {
  const [springProps, set] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 5, tension: 350, friction: 40 },
  }));
  const [bounding, setBounding] = useState(null);
  const ref = useRef();

  const calc = (x, y) => (bounding ? [-(y - bounding.bottom + bounding.height / 2) / 20,
    (x - bounding.right + bounding.width / 2) / 20, 1.1] : [0, 0, 1.1]);
  const trans = (x, y, s) => `perspective(450px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`;

  useEffect(() => {
    ['load', 'resize', 'scroll'].forEach((event) => window.addEventListener(event, () => {
      const boundingClientRect = ref && ref.current && ref.current.getBoundingClientRect();
      setBounding(boundingClientRect);
    }));
  }, [ref]);

  return (
    <animated.div
      onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
      onMouseLeave={() => set({ xys: [0, 0, 1] })}
      style={{ transform: springProps.xys.interpolate(trans) }}
      ref={ref}
    >
      <FloatingCard url={url} cardText={cardText} onClick={onClick} />
    </animated.div>
  );
}

export default FloatingCard3D;
